module.exports = __webpack_public_path__ + "img/2.70369d21.jpg";